import { DueDateSettingType, FinanceType, TransactionType } from "@/enums/enums";

export function GetDueDateFromSetting(settingTransactionDueDate: any, selectedContact: any, transactionTypeModel: any) {
  let dueDateResult: any = { isDueDateSetting: false };
  if (settingTransactionDueDate) {
    const settingTransaction = settingTransactionDueDate.find(
      (x: any) =>
        x.transactionType === transactionTypeModel.transactionType && x.financeType === transactionTypeModel.financeType
    );
    if (settingTransaction && settingTransaction.dueDateType !== DueDateSettingType.None) {
      dueDateResult = {
        isDueDateSetting: true,
        dueDateType: settingTransaction.settingDueDateType,
        day: settingTransaction.day,
      };
    }
  }
  if (
    selectedContact &&
    selectedContact.id &&
    selectedContact.id > 0 &&
    transactionTypeModel.transactionType == TransactionType.Invoice
  ) {
    if (
      transactionTypeModel.financeType == FinanceType.OutFlow &&
      selectedContact.outflowDueDateTypeId !== DueDateSettingType.None
    ) {
      dueDateResult = {
        isDueDateSetting: true,
        dueDateType: selectedContact.outflowDueDateTypeId,
        day: selectedContact.outflowDueDateDay,
      };
    } else if (selectedContact.incomeDueDateTypeId !== DueDateSettingType.None) {
      dueDateResult = {
        isDueDateSetting: true,
        dueDateType: selectedContact.incomeDueDateTypeId,
        day: selectedContact.incomeDueDateDay,
      };
    }
  }
  return dueDateResult;
}

export function SetDueDate(startDate: any, dueDateType: DueDateSettingType, day: number) {
  let date = new Date(startDate);
  switch (dueDateType) {
    case DueDateSettingType.DateDistanctNextMonth:
      date = new Date(date.getFullYear(), date.getMonth() + 1, day);
      break;
    case DueDateSettingType.EndOfMonth:
      date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      break;
    case DueDateSettingType.EndOfMonthFromNextMonth:
      date = new Date(date.getFullYear(), date.getMonth() + 2, 0);
      break;
    default:
      date.setDate(date.getDate() + day);
      break;
  }
  return date.ToDateJsonString();
}
